module.exports = __webpack_public_path__ + "static/media/Presence.ca76f014.svg";